// Initialization object
async function init(mountId: string) {
	const mount = document.getElementById(mountId);

	if (mount) {
		mount.innerHTML = `
       <div id="loading-indicator" class="text-white text-center mt-5">
         <div class="spinner-border text-white mt-5" role="status"></div>
       </div>
     `;
	}
}

export default init;
